import React from 'react'
import { useSelector } from 'react-redux'

import { havePermissionsFailed } from '@/reducers/auth/currentUser.redux'

import { AnnouncementBanner } from './AnnouncementBanner'

/**
 * Shown when an RBAC-enforced user's permissions could not be loaded. The UI
 * then falls back to legacy flags, so pages may offer actions the backend
 * refuses — this tells the user why, and how to retry.
 *
 * @import { PermissionsUnavailableBanner } from '@/components/banners/PermissionsUnavailableBanner'
 */
export const PermissionsUnavailableBanner = () => {
  const currentUser = useSelector((state) => state.currentUser)
  const currentOrganization = useSelector((state) => state.currentOrganization)

  if (!havePermissionsFailed(currentUser, currentOrganization)) {
    return null
  }

  return (
    <AnnouncementBanner
      dataTestId="permissions-unavailable-banner"
      actionLabel="Refresh"
      onAction={() => window.location.reload()}
    >
      We couldn&apos;t load your permissions, so some pages or actions may not work. Refresh to try
      again.
    </AnnouncementBanner>
  )
}
